var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"play-back-item"},[_c('replay',{attrs:{"replayData":_vm.itemData}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }